import React from "react";
import Index from "../views/dashboard/index";
// import { Switch, Route } from 'react-router-dom'

// Dashboard Detail
import DashPrimer from "../views/dashboard/dashprimer";
import DashPasca from "../views/dashboard/dashpasca";
import DashEkspor from "../views/dashboard/dashekspor";

//admin
import Default from "../layouts/dashboard/default";

//ekspor
import Draft from "../views/permohonan/ekspor/Draft";
import OnProcess from "../views/permohonan/ekspor/OnProcess";
import Disetujui from "../views/permohonan/ekspor/Disetujui";
import Ditolak from "../views/permohonan/ekspor/Ditolak";
import Daftar from "../views/penugasan/Daftar";
import DaftarSelesai from "../views/penugasan/DaftarSelesai";
import ViewEditEkspor2 from "../views/permohonan/ekspor/ViewEditEkspor2";

//impor
import DraftImpor from "../views/permohonan/impor/Draft";
import OnProcessImpor from "../views/permohonan/impor/OnProcess";
import DisetujuiImpor from "../views/permohonan/impor/Disetujui";
import RealisasiPostBorder from "../views/permohonan/impor/RealisasiPostBorder";

//master
import MasterIkan from "../views/master/MasterIkan";
import MasterIkanSatuan from "../views/master/MasterIkanSatuan";
import Kemasan from "../views/master/Kemasan";
import Bentuk from "../views/master/Bentuk";
import Disposisi from "../views/master/Disposisi";
import HasilUji from "../views/master/HasilUji";
import JenisHcm from "../views/master/JenisHcm";
import JenisKegiatan from "../views/master/JenisKegiatan";
import JenisUji from "../views/master/JenisUji";
import Kecamatan from "../views/master/Kecamatan";
import Kesimpulan from "../views/master/Kesimpulan";
import MasterHs from "../views/master/Hs";
import MetodeLab from "../views/master/MetodeLab";
import Negara from "../views/master/Negara";
import Pelabuhan from "../views/master/Pelabuhan";
import TarifPnbp from "../views/master/TarifPnbp";
import PelabuhanPendaratan from "../views/master/PelabuhanPendaratan";

//setting
import Pengguna from "../views/setting/Pengguna";
import RolePengguna from "../views/setting/RolePengguna";
import Upt from "../views/setting/Unit";
// import Trader from "../views/setting/Trader";
import Traders from "../views/setting/Traders";
import EditTRader from "../views/setting/edit-trader";
import EditPegawai from "../views/setting/edit-pegawai";
import Partner from "../views/setting/Partner";
import Upi from "../views/setting/Upi";
import Login from "../views/dashboard/auth/sign-in";
import SignUp from "../views/dashboard/auth/sign-up";
import Registrasi from "../views/registrasi/index";

// Ingat ini hanya template
// import Registrasi2 from "../views/registrasi/registrasi";

import Profile from "../views/setting/traderProfile";
import DataPegawai from '../views/setting/DataPegawai';

import ResetPassword from '../views/dashboard/Password/resetpassword';
// Supplier
import SupplierPage from "../views/setting/Supplier";
import EditUpiSupplier from "../views/setting/EditSupplier";

// statistik
import Statistik from "../views/statistik/index";

//pbumku
import DaftarPrimer from "../views/pbumku/primer/DaftarPrimer";
import DokChecklist from "../views/pbumku/primer/DokChecklist";
import UpiAddEdit from "../views/setting/UpiAddEdit";
import PartnerAddEdit from "../views/setting/PartnerAddEdit";
import MasterIkanAddEdit from "../views/master/MasterIkanAddEdit";
import TraderAlamat from "../views/setting/TraderAlamat";
import TraderAlamatAddEdit from "../views/setting/TraderAlamatAddEdit";
import DaftarEvAdmin from "../views/penugasan/DaftarEvAdmin";
import DaftarProses from "../views/penugasan/DaftarProses";
import DaftarEvTeknis from "../views/penugasan/DaftarEvTeknis";
import DaftarTerbitDraft from "../views/penugasan/DaftarTerbitDraft";
import DaftarSetujuDraft from "../views/penugasan/DaftarSetujuDraft";

//view smkhp
import QRCode from "../views/viewsmkhp/QRCode";
import FormH from "../views/viewsmkhp/formH";

// report
import ReportSMKHP from "../views/report/ReportSMKHP";
import ReportUMKU from "../views/report/ReportPBUMKU";
import ReportPasca from "../views/report/ReportPascaPanen"

// nonlalin
import DraftNonLalin from "../views/nonlalin/permohonan/DraftNonLalin";
import DaftarMasuk from "../views/nonlalin/penugasan/DaftarMasuk";
import ViewEditNonLalin from "../views/nonlalin/permohonan/ViewEditNonLalin";
import OnProcessNonLalin from "../views/nonlalin/permohonan/OnProcessNonLalin";
import DaftarLab from "../views/nonlalin/penugasan/DaftarLab";
import DaftarJasaLainnya from "../views/nonlalin/penugasan/DaftarJasaLainnya";
import DaftarScanning from "../views/nonlalin/penugasan/DaftarScanning";

//kapal
import DraftKapal from "../views/pbumku/kapal/permohonan/DraftKapal";
import MasterKapal from "../views/pbumku/kapal/master/MasterKapal";
import ViewEditKapal from "../views/pbumku/kapal/permohonan/ViewEditKapal";
import EvpKapal from "../views/pbumku/kapal/penugasan/EvpKapal";
import InspeksiKapal from "../views/pbumku/kapal/penugasan/InspeksiKapal";
import OnProcessKapal from "../views/pbumku/kapal/permohonan/OnProcessKapal";
import TerbitKapal from "../views/pbumku/kapal/permohonan/TerbitKapal";
import TolakKapal from "../views/pbumku/kapal/permohonan/TolakKapal";
import EvtKapal from "../views/pbumku/kapal/penugasan/EvtKapal";

//billing
import DaftarBilling from "../views/billing/Daftar";
import DaftarPnbp from "../views/billing/DaftarPnbp";

// import FormSampelView from "../views/cetak/cesium/FormSampel";
// import FormPemindaianView from "../views/cetak/cesium/FormPemindaian";
// import AppendixView from "../views/cetak/draft/DraftAppendixFarm";
// import CetakAuditView from "../views/cetak/kapal/AuditKecukupan";
// import PenagguhanInspeksiView from "../views/cetak/kapal/PenangguhanInspeksi";

export const DefaultRouter = [
  {
    path: "/",
    element: <Default />,
    children: [
      {
        path: "dashboard",
        element: <Index />,
      },
      // Dashboard Detail
      {
        path: "dashboard/primer",
        element: <DashPrimer />,
      },
      {
        path: "dashboard/pasca",
        element: <DashPasca />,
      },
      { 
        path: "dashboard/ekspor", 
        element: <DashEkspor /> 
      },
      // Ekspor
      {
        path: "permohonan/ekspor/view-2",
        element: <ViewEditEkspor2 />,
      },
      {
        path: "permohonan/ekspor/draft",
        element: <Draft />,
      },
      {
        path: "permohonan/ekspor/onprocess",
        element: <OnProcess />,
      },
      {
        path: "permohonan/ekspor/disetujui",
        element: <Disetujui />,
      },
      {
        path: "permohonan/ekspor/ditolak",
        element: <Ditolak />,
      },
      {
        path: "penugasan/daftar",
        element: <Daftar />,
      },
      {
        path: "penugasan/daftar-proses",
        element: <DaftarProses />,
      },
      {
        path: "penugasan/daftar-ev-admin",
        element: <DaftarEvAdmin />,
      },
      {
        path: "penugasan/daftar-ev-teknis",
        element: <DaftarEvTeknis />,
      },
      {
        path: "penugasan/daftar-terbit-draft",
        element: <DaftarTerbitDraft />,
      },
      {
        path: "penugasan/daftar-setuju-draft",
        element: <DaftarSetujuDraft />,
      },
      {
        path: "penugasan/daftar-selesai",
        element: <DaftarSelesai />,
      },
      //impor
      {
        path: "permohonan/impor/draft",
        element: <DraftImpor />,
      },
      {
        path: "permohonan/impor/onprocess",
        element: <OnProcessImpor />,
      },
      {
        path: "permohonan/impor/disetujui",
        element: <DisetujuiImpor />,
      },
      {
        path: "permohonan/impor/realisasipostborder",
        element: <RealisasiPostBorder />,
      },
      //master
      {
        path: "master/ikan",
        element: <MasterIkan />,
      },
      {
        path: "master/ikan-add-edit",
        element: <MasterIkanAddEdit />,
      },
      {
        path: "master/satuanikan",
        element: <MasterIkanSatuan />,
      },
      {
        path: "master/kemasan",
        element: <Kemasan />,
      },
      {
        path: "master/bentuk",
        element: <Bentuk />,
      },
      {
        path: "master/disposisi",
        element: <Disposisi />,
      },
      {
        path: "master/hasiluji",
        element: <HasilUji />,
      },
      {
        path: "master/jenishcm",
        element: <JenisHcm />,
      },
      {
        path: "master/jeniskegiatan",
        element: <JenisKegiatan />,
      },
      {
        path: "master/jenisuji",
        element: <JenisUji />,
      },
      {
        path: "master/kecamatan",
        element: <Kecamatan />,
      },
      {
        path: "master/kesimpulan",
        element: <Kesimpulan />,
      },
      {
        path: "master/hs",
        element: <MasterHs />,
      },
      {
        path: "master/metodelab",
        element: <MetodeLab />,
      },
      {
        path: "master/negara",
        element: <Negara />,
      },
      {
        path: "master/pelabuhan",
        element: <Pelabuhan />,
      },
      {
        path: "master/tarifpnbp",
        element: <TarifPnbp />,
      },
      {
        path: "master/pelabuhan-pendaratan",
        element: <PelabuhanPendaratan />,
      },
    
        //Master Pegawai
      {
      path: 'data/pegawai',
      element: <DataPegawai />
      },

      //pbumku
      {
        path: "pbumku/daftar-primer",
        element: <DaftarPrimer />,
      },
      {
        path: "pbumku/dokumen-checklist",
        element: <DokChecklist />,
      },
      {
        path: "pbumku/kapal/draft-kapal",
        element: <DraftKapal/>
      },
      {
        path: "pbumku/kapal/onprocess-kapal",
        element: <OnProcessKapal/>
      },
      {
        path: "pbumku/kapal/evp-kapal",
        element: <EvpKapal/>
      },
      {
        path: "pbumku/kapal/inspeksi-kapal",
        element: <InspeksiKapal/>
      },
      {
        path: "pbumku/kapal/evt-kapal",
        element: <EvtKapal/>
      },
      {
        path: "pbumku/kapal/terbit-kapal",
        element: <TerbitKapal/>
      },
      {
        path: "pbumku/kapal/reject-kapal",
        element: <TolakKapal/>
      },
      {
        path: "pbumku/kapal/view-kapal",
        element: <ViewEditKapal/>
      },
      {
        path: "pbumku/kapal/master-kapal",
        element: <MasterKapal/>
      },
      //setting
      {
        path: "setting/pengguna",
        element: <Pengguna />,
      },
      {
        path: "setting/rolepengguna",
        element: <RolePengguna />,
      },
      {
        path: "setting/upt",
        element: <Upt />,
      },
      {
        path: "setting/upi",
        element: <Upi />,
      },
      {
        path: "setting/upi-add-edit",
        element: <UpiAddEdit />,
      },
      {
        path: "setting/trader",
        element: <Traders />,
      },
      {
        path: "setting/edit-trader",
        element: <EditTRader />,
      },
      {
        path: "setting/edit-pegawai",
        element: <EditPegawai />,
      },
      {
        path: "setting/partner",
        element: <Partner />,
      },
      {
        path: "setting/partner-add-edit",
        element: <PartnerAddEdit />,
      },
      {
        path: "setting/trader-alamat",
        element: <TraderAlamat />,
      },
      {
        path: "setting/trader-alamat-add-edit",
        element: <TraderAlamatAddEdit />,
      },
      {
        path: "setting/trader-profile",
        element: <Profile />,
      },
      {
        path: "setting/supplier",
        element: <SupplierPage />,
      },      {
        path: "setting/edit-supplier",
        element: <EditUpiSupplier/>,
      },
      // reporting
      {
        path: "report/report-smkhp",
        element: <ReportSMKHP />,
      },
      {
        path: "report/report-umku",
        element: <ReportUMKU />,
      },
      {
        path: "/report/report-pasca",
        element: <ReportPasca/>
      },

      // nonlalin
      {
        path: "nonlalin/draft",
        element: <DraftNonLalin />,
      },
      {
        path: "nonlalin/onprocess",
        element: <OnProcessNonLalin />,
      },
      {
        path: "nonlalin/view",
        element: <ViewEditNonLalin />,
      },
      {
        path: "nonlalin/daftar-masuk",
        element: <DaftarMasuk />,
      },
      {
        path: "nonlalin/daftar-lab",
        element: <DaftarLab />,
      },
      {
        path: "nonlalin/daftar-lainnya",
        element: <DaftarJasaLainnya />,
      },
      {
        path: "nonlalin/daftar-scanning",
        element: <DaftarScanning />,
      },

      // pnbp billing
      {
        path: "billing/daftar",
        element: <DaftarBilling/>
      },
      {
        path: "billing/daftar-pnbp",
        element: <DaftarPnbp/>
      }
    ],
  },
  {
    path: "login",
    element: <Login />,
  },
  {
    path: "update-password",
    element: <SignUp />,
  },
  {
    path: "registrasi",
    element: <Registrasi />,
  },

  // Ingat ini hanya template
  // {
  //   path: "registrasi2",
  //   element: <Registrasi2 />,
  // },

  {
    path: "view-smkhp/:noAju",
    element: <QRCode />,
  },
   {
    path: "reset-password/:token",
    element: <ResetPassword />,
  },
  {
    path: "view-smkhp/H/:noAju",
    element: <FormH />,
  },
  {
    path: "statistik",
    element: <Statistik />,
  },
];
